import React, { useState, useContext, useEffect } from 'react';
import { Image, Grid, Button, Icon } from 'semantic-ui-react';
import NumberInput from 'semantic-ui-react-numberinput';
import PanierContext from './../../contexts/PanierContext';
import GlobalContext from './../../contexts/GlobalContext';
import AmountProvider from './../Provider/AmountProvider';
import Utility from './../../Utility';

const PanierItem = props => {
  const [globalContext] = useContext(GlobalContext);
  const [, panierDispatch] = useContext(PanierContext);
  const [quantityState, setQuantityState] = useState(1);

  useEffect(() => {
    if(props.item.quantity !== undefined) {
      setQuantityState(props.item.quantity);
    }
  }, [props.item.quantity]);

  /**
   * set Nouvelle quantité
   * @param {int} newQuantity 
   */
  const handleChange = newQuantity => {
    newQuantity = parseInt(newQuantity);
    setQuantityState(newQuantity);
    panierDispatch({type:'UPDATE_QUANTITY', folderId: props.folderId, bookingId: props.bookingId, quantity: newQuantity, payload: props.item})
  }
  
  return (
    <Grid style={{ height: "100%" }} columns="equal">
      <Grid.Row>
        <Grid.Column computer={4} mobile={16}>
          <Image src={Utility.imageExists(props.item.image)} />
        </Grid.Column>
        <Grid.Column computer={12} mobile={16}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <h3>{props.item.name}</h3>
            </div>
            <div className="">
              <Button
                style={{ background: 'transparent' }}
                icon
                onClick={() => panierDispatch({ type: "DELETE_PRODUCT", payload: props.item, folderId: props.folderId, bookingId: props.bookingId })}
                floated="right">
                <Icon color="grey" name="trash alternate" />
              </Button>
            </div>
          </div>
          <div>
            <div className="panier-input-div" style={{ textAlign: 'left'}}>
              <NumberInput maxLength={5} size="mini" minValue={1} maxValue={99} value={quantityState.toString()} onChange={handleChange} /> 
            </div>
            <h4 style={{ textAlign: 'right' }}>{globalContext.translations.price}: <AmountProvider amount={props.item.panierTotalPrice} currency={props.item.currency} /></h4>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

export default PanierItem;